import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import { Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';
// import useLogic from './logic';

const Wrapper = styled(FlexView)`
  border-radius: 8px;
  border: 1px solid ${COLORS.GHOST};
  margin-bottom: 16px;
`;

const LicenseCard = ({ id, program, categoryList, geos }) => {
  // keeping this as we'll have edit license later
  // const isEditable = false;
  // const { handleEditLicense } = useLogic({ id, program, gradeGroups, geos });

  return (
    <Wrapper gutter={16} gap={16}>
      <Row justifyContent="space-between">
        <Col gutter={0}>
          <Text variant="h5">{program}</Text>
        </Col>
        {/* {isEditable && (
          <Col gutter={0}>
            <Button
              label="Edit"
              variant="tertiaryWithUnderline"
              onClick={handleEditLicense}
              size="xsmall"
              width="75px"
            />
          </Col>
        )} */}
      </Row>
      <Separator height={16} />
      <Separator height={8} />
      <Row alignItems="center" justifyContent="space-between">
        <Col gutter={0}>
          <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
            REGIONS
          </Text>
        </Col>
        <Col gutter={0}>
          <Text variant="body2">{geos?.join(', ')}</Text>
        </Col>
      </Row>
      <Separator height={8} />
      <Row alignItems="center" justifyContent="space-between">
        <Col gutter={0}>
          <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
            Category
          </Text>
        </Col>
        <Col gutter={0}>
          <Text variant="body2">{categoryList?.join(', ')}</Text>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default LicenseCard;
